﻿import { Component, OnInit, Input } from '@angular/core';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { SiteEntityContactParam } from '../../viewmodel';
import { SiteEntityParam } from '../../viewmodel';
import { SharedService } from '../../services/shared.service';
import { HelperService } from '../../services/helper.service';
import { EntityService } from '../../services/entity.service';
import { FoucsChangeService } from '../../services/focuschange.service';

@Component({
    selector: 'site-entity-detail',
    templateUrl: './siteentitydetail.component.html'
})
export class SiteEntityDetailComponent implements OnInit {
    @Input() entity: any;
    projectId: number = 0;
    siteAddress: string = ''; 
    showDeleteSiteContactPopup: boolean = false;
    deleteSiteContactId: number = 0;
    @Input('isAppEditable') isAppEditable: boolean = false;

    constructor(private router: Router
        , private activeRoute: ActivatedRoute        
        , private sharedService: SharedService
        , private helperService: HelperService
        , private entityService: EntityService
        , private foucsChangeService: FoucsChangeService) { }

    ngOnInit() {
        let id = this.sharedService.getData('id');
        if (id != null) {
            let ids = JSON.parse(id);
            if (ids.projectId != null) {
                this.projectId = ids.projectId;
            }
        }
    }

    addSiteContact(entity) {
        if (entity == null)
            return false;

        this.setSiteEntityParam(entity)
        this.router.navigate(['/entity/addsitecontacts']);
    }

    setSiteEntityParam(sEntity) {
        var sep = new SiteEntityParam();
        sep.projectId = this.projectId;
        sep.siteProjectBuildingId = sEntity.MIHProjectBuildingID      //this.entity.ProjectBuildingID;   794784
        sep.bldgId = sEntity.BldgID    //this.entity.BuildingID;
        sep.companyName = sEntity.PartyName;    //this.entity.organization;
        sep.partyRoleSeqNo = sEntity.PartyRoleLookup.SeqNo  //this.entity.entityRole;
        sep.partyRoleName = this.helperService.getSiteRoleName(sEntity.PartyRoleLookup.SeqNo);  //this.helperService.getSiteRoleName(this.entity.entityRole);
        sep.mood = 'A';  //Add or Edit
        sep.projectBldgDevTeamId = sEntity.MIHProjectBldgDevTeamID;
        sep.partyId = sEntity.PartyID;
        sep.partyStagingId = sEntity.PartyStagingID;
        sep.partyAddressId = sEntity.PartyAddressID;
        sep.partyAddressStagingId = sEntity.PartyAddressStagingID;
        this.sharedService.setData('SiteEntityParam', JSON.stringify({ sep }));
    } 

    editSiteContact(contact, entity) {

        var secp = new SiteEntityContactParam();
        secp.projectBldgDevTeamContactId = contact.MIHProjectBldgDevTeamContactID;
        secp.ProjectBldgDevTeamID = contact.MIHProjectBldgDevTeamID;
        secp.siteProjectBuildingID = entity.MIHProjectBuildingID; //entity.siteProjectBuildingID; 
        secp.BuildingID = entity.BldgID; 
        secp.projectId = this.projectId;        
        secp.partyId = entity.PartyID;
        secp.partyStagingId = entity.PartyStagingID;   
        secp.commContactId = contact.CommContactID;     
        secp.companyName = entity.PartyName;
        secp.partyRoleName = entity.PartyRoleLookup.LongName;
        secp.roleId = entity.PartyRoleLookup.SeqNo;
        this.sharedService.setJsonData('SiteEntityContactParams', secp); 

        if (contact == null)
            this.router.navigate(['/entity/editsitecontact']);
        else {
            this.router.navigate(['/entity/editsitecontact']);

        }
    }

    /////DeleteSiteContact////
    cancelDeleteSiteContact(event) {
        this.showDeleteSiteContactPopup = false;
        this.deleteSiteContactId = 0;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }

    clickDeleteSiteContact(siteContactId) {
        this.deleteSiteContactId = siteContactId;
        this.showDeleteSiteContactPopup = true; 
        this.foucsChangeService.changeFocus(false);
    }

    deleteSiteContact(siteContactId) {
        if (siteContactId > 0) {
            this.entityService.deleteSiteTeamContact(siteContactId)
                .subscribe(
                success => {
                    if (!success.Success) {
                    }
                    else {
                        this.showDeleteSiteContactPopup = false;
                        this.deleteSiteContactId = 0;
                        this.foucsChangeService.changeFocus(true);
                        window.location.reload();
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.deleteSiteContactId = 0;
                    //this.pageSuccess = []; this.pageError = [];
                    //this.pageError.push(error.ExceptionMessage);
                    window.scrollTo(0, 0);
                })
        }
    }

    getFormattedAddressLine(entity) {
        var ret = '';
        if (entity == null)
            return ret;

        if (entity.PartyAddress1 != null)
            ret += entity.PartyAddress1;

        if (entity.PartyAddress2 != null && entity.PartyAddress2 != '')
            ret += ', ' + entity.PartyAddress2;

        return ret;
    }


}
